import { render, staticRenderFns } from "./AddEditPaymentMethodDialog.vue?vue&type=template&id=5f8cfd12"
import script from "./AddEditPaymentMethodDialog.vue?vue&type=script&lang=js"
export * from "./AddEditPaymentMethodDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports